"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    messageType
  } = props;
  const ccModalHeaderStyle = (0, _react.useMemo)(() => {
    const messageTypeProps = () => {
      let color;
      switch (messageType) {
        case 'alert':
          color = themeColors?.general.alert;
          break;
        case 'success':
          color = themeColors?.general.success;
          break;
        default:
          color = themeColors?.general.text;
          break;
      }
      return {
        color
      };
    };
    const mobileProps = () => {
      const padding = isMobileView ? `${pxToRem(19)} ${pxToRem(20)} 0` : `${pxToRem(19)} ${pxToRem(30)} 0`;
      return {
        padding
      };
    };
    const ccModalHeader = (0, _css.css)({
      flex: '0 1 auto',
      ...mobileProps()
    });
    const ccModalHeaderMessage = (0, _css.css)({
      position: 'relative',
      fontWeight: 'bold',
      marginBottom: pxToRem(5),
      ...messageTypeProps()
    });
    const ccModalHeaderMessageIcon = (0, _css.css)({
      width: pxToRem(20),
      height: pxToRem(20),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: pxToRem(1),
      backgroundColor: 'currentColor',
      borderRadius: '50%'
    });
    const ccModalHeaderMessageText = (0, _css.css)({
      fontSize: pxToRem(20),
      marginInlineStart: pxToRem(28),
      lineHeight: 1.2
    });
    const ccModalHeaderTitle = (0, _css.css)({
      fontSize: pxToRem(26),
      color: themeColors?.primary.dark,
      margin: 0,
      marginBottom: pxToRem(5),
      lineHeight: 1.05
    });
    const ccModalHeaderSubTitle = (0, _css.css)({
      fontSize: pxToRem(26),
      color: themeColors?.general.text,
      margin: 0,
      lineHeight: 1.2,
      '&:first-child': {
        marginTop: pxToRem(19)
      }
    });
    return {
      ccModalHeader,
      ccModalHeaderMessage,
      ccModalHeaderMessageIcon,
      ccModalHeaderMessageText,
      ccModalHeaderTitle,
      ccModalHeaderSubTitle
    };
  }, [isMobileView, messageType, pxToRem, themeColors?.general.alert, themeColors?.general.success, themeColors?.general.text, themeColors?.primary.dark]);
  return {
    'cc-ModalHeader': ccModalHeaderStyle.ccModalHeader,
    'cc-ModalHeader__message': ccModalHeaderStyle.ccModalHeaderMessage,
    'cc-ModalHeader__message__icon': ccModalHeaderStyle.ccModalHeaderMessageIcon,
    'cc-ModalHeader__message__text': ccModalHeaderStyle.ccModalHeaderMessageText,
    'cc-ModalHeader__title': ccModalHeaderStyle.ccModalHeaderTitle,
    'cc-ModalHeader__sub-title': ccModalHeaderStyle.ccModalHeaderSubTitle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;